
export function blobToBase64(blob) {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

export function formatNumberto0(num) {
    return num >= 10 ? `${num}` : `0${num}`;
}


export function formatPrice(price) {
    const symbols = ["", "K", "M", "B", "T", "Q", "Qu"]; // Magnitude symbols
    const magnitude = Math.floor(Math.log10(price) / 3); // Calculate magnitude
    let convertedPrice = price / Math.pow(10, magnitude * 3);
    convertedPrice = convertedPrice.toFixed(2); // Ensure 2 decimal places
    return `${convertedPrice}${symbols[magnitude]}`;
  }
  

export function formateNumbersToComma(number) {
    if (!number || number === "") return "";

    let originalNumber = parseFloat(number);
    let roundedNumber = Math.ceil(originalNumber);

    let numberStr = roundedNumber.toString();

    // Check if the price contains a decimal point
    let decimalIndex = numberStr.indexOf(".");
    let decimalPart = "";
    if (decimalIndex !== -1) {
        // Extract the decimal part of the price
        decimalPart = numberStr.slice(decimalIndex);
        numberStr = numberStr.slice(0, decimalIndex);
    }

    // Add commas every three digits from the right
    let formattedPrice = "";
    for (let i = numberStr.length - 1, count = 0; i >= 0; i--, count++) {
        if (count && count % 3 === 0) {
            formattedPrice = "," + formattedPrice;
        }
        formattedPrice = numberStr[i] + formattedPrice;
    }

    // Append the decimal part and return the formatted price
    let resValue = `${formattedPrice + decimalPart}`;

    return resValue;
}


export function formatDateTimeForMsg(date) {

    if (date instanceof Date) {
        const now = new Date();
        const diff = now - date; // Difference in milliseconds
        // Format time if the date is today
        if (diff < 86400000 && date.getDate() === now.getDate()) {
            return date.toLocaleTimeString('en-US', {hour: 'numeric', minute: 'numeric'});
        }
        // Format as "Yesterday" if the date is yesterday
        if (diff < 172800000 && date.getDate() === now.getDate() - 1) {
            return 'Yesterday ' + date.toLocaleTimeString('en-US', {hour: 'numeric', minute: 'numeric'});
        }
        return date.toLocaleString('en-US').replace(/\//g, '-');

    } else return ""
}

export function nFormatter(num, digits) {
    const lookup = [
        {value: 1, symbol: ""},
        {value: 1e3, symbol: "k"},
        {value: 1e6, symbol: "M"},
        {value: 1e9, symbol: "G"},
        {value: 1e12, symbol: "T"},
        {value: 1e15, symbol: "P"},
        {value: 1e18, symbol: "E"}
    ];
    const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/;
    const item = lookup.findLast(item => num >= item.value);
    return item ? (num / item.value).toFixed(digits).replace(regexp, "").concat(item.symbol) : "0";
}

export function sleep(milliseconds = 1) {
    return new Promise(resolve => {
        setTimeout(resolve, milliseconds); // Wait for 1 minute (60,000 milliseconds)
    });
}

export const SUBSCRIPTION_ENABLED = false; // Set to true or false based on your requirement
